import React, { Component, Fragment } from 'react'
import { generateFundDetailUrl } from '../../Helpers/FundUtility.js'
import './MutualFundViewer.css'
import {
  retrieveCusip,
  sortBySubcategory,
  splitGroupedFundsWithNoCategory,
  addTickerSymbol,
  sortAlphaByProp,
} from './Helpers/FundViewerUtility.js'
import DOMPurify from 'dompurify'

class MutualFundViewer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      fundClass: this.props.fundHeader ? this.props.fundHeader.fundClass : null,
      selectedCategory: this.getDefaultSelectedCategory(),
      displayedProducts: null,
    }
  }

  getModelPortfoliosSelectedCategory = () => {
    const _productList = this.props.productList
    const _fundName = this.props.fundName

    return _productList.filter((product) => {
      return product.funds.find((fund) => fund.fundName === _fundName)
    })[0].ctgName
  }

  getDefaultSelectedCategory = () => {
    if (
      this.props.fundHeader &&
      this.props.fundHeader.investCatg &&
      !this.props.isModelPortfolios
    ) {
      return this.props.fundHeader.investCatg
    } else if (this.props.productList && this.props.productList.length > 0) {
      if (this.props.isModelPortfolios) {
        return this.getModelPortfoliosSelectedCategory()
      } else {
        return this.props.productList[0].ctgName
      }
    } else {
      return 'Equity'
    }
  }

  changeSelectedCategory = (event) => {
    this.setState({
      selectedCategory: event.currentTarget.dataset.category,
    })
  }

  changeSelectedCategoryMobile = (event) => {
    this.setState({
      selectedCategory: event.target.selectedOptions[0].value,
    })
  }

  renderCategoryMobileDropdown() {
    const { productList } = this.props

    return (
      <div className="Dropdown Dropdown--reversed u-md-hidden u-lg-hidden u-sm-block u-sm-marginBottom1gu">
        <select
          onChange={this.changeSelectedCategoryMobile}
          className="Dropdown-menu"
          id="mutual-fund-viewer-mobile-category-dropdown"
          data-analytics="fund-viewer-category"
        >
          {productList.map((product) => {
            return (
              <option key={product.ctgName} value={product.ctgName}>
                {product.ctgName}
              </option>
            )
          })}
        </select>
      </div>
    )
  }

  renderProductList() {
    const { productList, isModelPortfolios } = this.props

    const modelPortfolioOrder = ['Conservative', 'Moderate', 'Aggressive']

    if (isModelPortfolios) {
      productList.sort(
        (a, b) =>
          modelPortfolioOrder.indexOf(a.ctgName) -
          modelPortfolioOrder.indexOf(b.ctgName)
      )
    }

    return productList.map((product, index) => {
      return (
        <Fragment key={`Product-Fragment-${index}`}>
          <li
            className={`List-item u-cursorPointer u-borderTop u-paddingVert0
              ${
                this.state.selectedCategory === product.ctgName
                  ? 'u-bgColorBrandLightest'
                  : ''
              }`}
            key={product.ctgName}
            onClick={this.changeSelectedCategory}
            data-category={product.ctgName}
          >
            <h3
              className={`u-paddingHoriz2gu u-paddingVert4gu u-borderLeft u-borderWidthLarge  
            ${
              this.state.selectedCategory === product.ctgName
                ? 'u-textColorBrandLight u-borderColorTertiary'
                : 'u-textColorBrand u-borderLeftTransparent'
            }`}
            >
              {product.ctgName}
            </h3>
          </li>
        </Fragment>
      )
    })
  }

  renderFunds() {
    const { productList, isEtf, isEtfIndex } = this.props

    addTickerSymbol(productList)

    if (isEtf || isEtfIndex) {
      sortAlphaByProp(productList, 'symbol')
    } else {
      sortAlphaByProp(productList, 'fundName')
    }

    return productList.map((product) => {
      if (product.ctgName === this.state.selectedCategory && product.funds) {
        const groupedFunds = this.groupFunds(product.funds)

        return Object.keys(groupedFunds).map((category) => {
          return (
            <div
              className="u-marginBottom6gu u-md-size1of2 u-lg-size1of3 u-sm-sizeFull u-sm-flexBasisAuto"
              key={category}
            >
              {category !== 'noCategory' && category !== 'noCategorySlice' && (
                <h3 className="u-paddingBottom2gu">{category}</h3>
              )}
              <ul className="List" data-analytics="fund-viewer-links">
                {groupedFunds[category].map((fund) => {
                  return (
                    <li className="List-item" key={fund.fundName}>
                      <a
                        className="Link u-textSecondary"
                        href={DOMPurify.sanitize(fund.url)}
                      >
                        {fund.symbol && (
                          <span className="u-paddingRight1gu u-textBold">
                            {fund.symbol}
                          </span>
                        )}
                        {fund.fundName}
                      </a>
                    </li>
                  )
                })}
              </ul>
            </div>
          )
        })
      }
    })
  }

  groupFunds(funds) {
    const { isEtf, isEtfIndex, fundPath } = this.props
    const { fundClass } = this.state
    const maxFundsPerColumn = 15
    const groupedFunds = {}

    funds = funds.sort(sortBySubcategory)

    funds.map((fund) => {
      const category =
        fund.subCtgValue === null ? 'noCategory' : fund.subCtgValue
      const cusipClass = retrieveCusip(fund, fundClass)

      if (!groupedFunds[category]) {
        groupedFunds[category] = []
      }

      fund.symbol = isEtf || isEtfIndex ? fund.classes[0].symbol : null

      fund.url = generateFundDetailUrl(
        fund,
        fundPath,
        cusipClass.fundClass,
        cusipClass.cusip
      )

      groupedFunds[category].push(fund)
    })

    const splitFunds =
      groupedFunds['noCategory'] &&
      groupedFunds['noCategory'].length > maxFundsPerColumn

    return splitFunds
      ? splitGroupedFundsWithNoCategory(groupedFunds['noCategory'])
      : groupedFunds
  }

  render() {
    return (
      <div className="Grid">
        <div className="u-size4of12 u-paddingRight5gu u-sm-paddingRight0 u-sm-sizeFull">
          {this.renderCategoryMobileDropdown()}
          <ul
            className="List u-sm-hidden"
            data-analytics="fund-viewer-category"
          >
            {this.renderProductList()}
            {!this.props.isEtf &&
              !this.props.isEtfIndex &&
              !this.props.isModelPortfolios && (
                <Fragment>
                  <li
                    key="top-performance-fund-link-1"
                    className="List-item u-borderTop u-paddingVert0"
                    data-url="/investment-products/mutual-funds?top-performing-funds=true"
                  >
                    <h3>
                      <a
                        href="https://www.columbiathreadneedleus.com/investment-products/mutual-funds?top-performing-funds=true"
                        className="u-linkClean u-block u-paddingHoriz2gu u-paddingVert4gu u-borderLeftTransparent u-borderWidthLarge u-textColorBrand u-borderColorTertiary"
                        target="_blank"
                        rel="noreferrer"
                      >
                        4 & 5 Star Funds
                      </a>
                    </h3>
                  </li>
                  <li
                    key="multi-managed-fund-link-1"
                    className="List-item u-borderTop u-borderBottom u-paddingVert0"
                    data-url="/investment-products/mutual-funds?multi-managed-funds=true"
                  >
                    <h3>
                      <a
                        href="https://www.columbiathreadneedleus.com/investment-products/mutual-funds?multi-managed-funds=true"
                        className="u-linkClean u-block u-paddingHoriz2gu u-paddingVert4gu u-borderLeftTransparent u-borderWidthLarge u-textColorBrand u-borderColorTertiary"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Multi-Manager Funds
                      </a>
                    </h3>
                  </li>
                </Fragment>
              )}
          </ul>
        </div>
        <div className="Grid Grid--alignTop Grid--fill Grid--flexMinSize1of3 Grid--withGutter u-size8of12 u-sm-sizeFull">
          {this.renderFunds()}
        </div>
      </div>
    )
  }
}

export default MutualFundViewer
